import { mutator } from 'satcheljs';
import {
    type RESET_SELECTIONActionMessage,
    resetSelectionOnTable,
} from 'owa-mail-actions/lib/mailListSelectionActions';
import resetExpansionViewStateInternal from 'owa-mail-list-store/lib/utils/resetExpansionViewStateInternal';
import clearSelection from 'owa-mail-list-store/lib/utils/clearSelection';

const defaultExport: (actionMessage: RESET_SELECTIONActionMessage) => void = mutator(
    resetSelectionOnTable,
    actionMessage => {
        const tableView = actionMessage.tableView;
        clearSelection(tableView);
        tableView.isInCheckedMode = false;
        tableView.isOnlyOptimisticallyInCheckedMode = false;
        resetExpansionViewStateInternal();
    }
);
export default defaultExport;
